







import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class AppText extends Vue {
  @Prop({ type: String, default: '' })
  readonly mod!: string;

  get modClasses(): Array<string> {
    const { mod } = this;
    if (!mod.length) return [];
    return mod.split(', ').map((item) => `text_${item}`);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/typography/Text/AppText.vue